enum JobWorkerOfferWorkerDeclinedReason {
    Undefined = -1,
    Salary = 1,
    FoundAnotherJob = 2,
    CounterOffer = 3,
    NoLongerLooking = 4,
}

export default JobWorkerOfferWorkerDeclinedReason;